import React, { Component } from 'react';
import { Spinner, Image } from 'react-bootstrap';
import { PageView, Event } from "../GoogleAnalytics";
import Loader from "../Loader/Loader";
import DeviceStateStatusIcon from './DeviceStateStatusIcon';

const csvBaseName = "EnergyMetrics.csv";
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
const columnsToExclude = ['partnerOrgId', 'customerOrgId', 'homeId', 'hvacId', 'assetId', 'events'];


function modifyArray(arrayOfObjects) {
    const modifiedArray = arrayOfObjects.map(obj => {
        const modifiedObj = { ...obj }; 
        columnsToExclude.forEach(variable => {
            delete modifiedObj[variable];
        });
        return modifiedObj;
    });
    return modifiedArray;
}

function convertToCSV(objArray) {
    const array = [Object.keys(objArray[0])].concat(objArray.map(obj => Object.values(obj)));
    return array.map(row => row.join(',')).join('\n');
};

function downloadCSV(data, deviceName, date) {
    Event("Download Data Clicked", "User clicked download data button in Partner Energy Metrics", "Download Data Clicked");
    var filenameWithDate = deviceName + "_" + months[date.getMonth()] + "_" + csvBaseName;
    var modifiedData = modifyArray(data);
    const csvContent = "data:text/csv;charset=utf-8," + encodeURIComponent(convertToCSV(modifiedData));

    const link = document.createElement("a");
    link.setAttribute("href", csvContent); // Set csvContent directly
    link.setAttribute("download", filenameWithDate || "data.csv");
    document.body.appendChild(link);
    link.click();
};

class DeviceEnergyMetricsTable extends Component {
    static defaultSortCol = "DATE";
    constructor(props) {
        super(props);

        //this.populateData = this.populateData.bind(this);

        this.state = {
            loading: false,
            columnSort: {
                enabled: true,
                type: "DATE",
                reverse: false
            },
            columnAltered: false,
            columnData: [],
            selected: -1,
            selectedDeviceName: ""
        };
    }

    onColumnClick(selectedCol) {
        const colSort = this.state.columnSort;
        let newSort = colSort;
        let data = this.props.deviceData;
        let colData = [];
        let colAltered = false;

        if (colSort.enabled) {
            if (colSort.type == selectedCol) {
                if (colSort.reverse) {
                    newSort = {
                        enabled: false,
                        type: null,
                        reverse: false
                    };
                    colData = this.props.columnSort(data, "DATE", false); /* default sort by is start time */
                    colAltered = false;
                }
                else {
                    newSort.reverse = true;
                    colData = this.props.columnSort(data, selectedCol, true);
                    colAltered = true;
                }
            }
            else {
                newSort = {
                    enabled: true,
                    type: selectedCol,
                    reverse: false
                };
                colData = this.props.columnSort(data, selectedCol, false);
                colAltered = true;
            }
        }
        else {
            newSort = {
                enabled: true,
                type: selectedCol,
                reverse: false
            };
            colData = this.props.columnSort(data, selectedCol, false);
            colAltered = true;
        }

        this.setState({ columnSort: newSort, columnData: colData }, () => {
            this.setState({ columnAltered: colAltered });
        });
    }

   translateStateToStatus(deviceState) {
        const states = deviceState.toLowerCase().split(',');

        let status = 0;

        states.forEach(state => {
            switch (state.trim()) {
                case 'reprovision':
                    status = -1;
                    break;
                case 'none':
                    status = 0;
                    break;
                case 'new':
                    status = 2;
                    break;
                default:
                    status = 1;
                    break;
            }
        });

        return status;
    }

    formatDate(dateString) {
        const date = new Date(dateString);
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();

        // Pad single-digit month and day with leading zero
        const formattedMonth = month < 10 ? `0${month}` : month;
        const formattedDay = day < 10 ? `0${day}` : day;

        return `${formattedMonth}-${formattedDay}-${year}`;
    }

    renderTable() {
        let deviceData = this.state.columnAltered ? this.state.columnData : this.props.deviceData;

        let deviceContent = deviceData.length ?
            <tbody>
                {deviceData.map((item, index) =>
                    [<tr className="alerts-table-row" key={item.runDate} data={index} value={index}>
                        <td className="padding-border-left">
                            {this.formatDate(item.runDate)}
                        </td>
                        <td>{item.kilowattHours.toFixed(2)}</td>
                        <td>{this.props.formatSeconds(item.timeRunning.toFixed(0))}</td>
                        <td>${item.cost.toFixed(2)}</td>
                        <td>{item.alerts}</td>
                        <td className="alerts-td-right text-center"><DeviceStateStatusIcon status={this.translateStateToStatus(item.deviceState)} /></td>
                    </tr>
                    ])}
            </tbody>
            : <tbody>
                <tr>
                    <td>{""}</td>
                </tr>
            </tbody>;


        return (
            <div className="energy-summary-container">
                <div>
                    <table className="table-hover width-100p" >

                        <thead>
                            <tr className="alerts-table-row">
                                <th className="pad-left-10">
                                    <div onClick={() => this.onColumnClick("DAY")}>
                                        <span className="cursor-pointer">DAY</span>
                                        {this.props.iconFunction("DAY", this.state.columnSort)}
                                    </div>
                                </th>
                                <th>
                                    <div onClick={() => this.onColumnClick("KWH")}>
                                        <span className="cursor-pointer">KWH</span>
                                        {this.props.iconFunction("KWH", this.state.columnSort)}
                                    </div>
                                </th>
                                <th>
                                    <div onClick={() => this.onColumnClick("TIME_RUNNING")}>
                                        <span className="cursor-pointer">TIME RUNNING</span>
                                        {this.props.iconFunction("TIME_RUNNING", this.state.columnSort)}
                                    </div>
                                </th>
                                <th>
                                    <div onClick={() => this.onColumnClick("ELECTRIC_COST")}>
                                        <span className="cursor-pointer">ELECTRIC COST</span>
                                        {this.props.iconFunction("ELECTRIC_COST", this.state.columnSort)}
                                    </div>
                                </th>
                                 <th>
                                    <div onClick={() => this.onColumnClick("ALERTS")}>
                                        <span className="cursor-pointer">ALERTS</span>
                                        {this.props.iconFunction("ALERTS", this.state.columnSort)}
                                    </div>
                                </th>
                                <th className="table-shrink center pad-10-10-10-5">
                                    <div onClick={() => this.onColumnClick("STATUS")}>
                                        <span className="cursor-pointer">STATUS</span>
                                        {this.props.iconFunction("STATUS", this.state.columnSort)}
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        {deviceContent}
                    </table>
                </div>
            </div>
        );
    }

    render() {
        const { classes } = this.props;
        let deviceName = this.props.deviceData[0].deviceName;
        let downloadBtn =
            <div className="row no-gutters alerts-tab-wrapper margin-0-30 pad-10-0" >
                <div className="col pad-right-30">
                    <button className="primary-btn btn-small width-150" onClick={() => downloadCSV(this.props.deviceData, deviceName, this.props.dateSelected)}>Download Data</button>
                </div>
            </div>

        let tableContents = false ? //this.state.tableLoading ?
            <Loader />
            : this.renderTable();

        return (

            <div>
                {tableContents}
                {downloadBtn}
            </div>
        );
    }
}

export default DeviceEnergyMetricsTable;